import { createElement } from 'react';
import { ChatTimeline } from '@/chat/ui/index.js';
import { useController } from '../../workspace/useWorkspace.jsx';

/** Minimal host Surface; sizing, position and visibility remain its consumer's UI state. */
export default function InlineChatApp(props = {}) {
  const controller = useController(props);
  const { viewModel, actionGuards, renderedTimelineItems, composerNode, generativeRegistry, handleUICardAction,
    handleWorkflowOperationAction, handleScenarioCardClick } = controller;
  return (
    createElement('section', { className: 'flare-chat-inline-surface', 'aria-label': 'Inline chat' },
      createElement(ChatTimeline, {
        items: renderedTimelineItems,
        isEmpty: renderedTimelineItems.length === 0,
        loading: viewModel.composer.loading,
        error: actionGuards.streamError,
        onRetry: actionGuards.handleRetry,
        registry: generativeRegistry,
        onUICardAction: handleUICardAction,
        onWorkflowOperationAction: handleWorkflowOperationAction,
        onMessageCapabilityAction: handleScenarioCardClick,
        messageWindow: viewModel.timeline.messageWindow,
        onLoadOlderMessages: viewModel.timeline.onLoadOlder,
      }),
      composerNode,
    )
  );
}
